export default "__VITE_ASSET__BPHyDhcF__"